import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #PAGINATION
\*------------------------------------ */
/**
 * Pagination wrapper
 */
.cat-c-pagination {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/**
* label style
*/
.cat-c-pagination__label {
  display: flex;
  gap: var(--cat-space-3x-small);
}

/**
 * Slot for content to be inserted after pagination
 */
.cat-c-pagination__after ::slotted(*) {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cat-pagination-footer,
.cat-pagination-inpage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.cat-pagination-footer-mobile {
  display: none;
}

.cat-is-mobile .cat-pagination-footer-mobile {
  display: block;
  width: 100%;
}
.cat-is-mobile .cat-pagination-footer-mobile .cat-c-pagination__list {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.cat-is-mobile .cat-pagination-footer {
  display: none;
}

/**
 * 1) Ordered list of links that allows for navigation to next/previous content
 */
.cat-c-pagination__list {
  display: flex; /* 1 */
  align-items: center;
  justify-content: center;
  list-style: none;
  padding: 0;
  gap: var(--cat-space-3x-small);
}

/**
 * pagination text with calculation
 */
.cat-c-pagination-label {
  flex-basis: 180px;
}

/**
 * pagination dropdown
 */
.cat-c-pagination-dropdown {
  display: flex;
  flex-basis: 180px;
  justify-content: end;
  /* Style for dropdown label */
}
.cat-c-pagination-dropdown .dropdown-show-text {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  color: var(--cat-theme-color-content-strong);
  display: flex;
  align-items: center;
  padding-inline-end: var(--cat-space-x-small);
}
.cat-c-pagination--hide-page-size .cat-c-pagination-dropdown {
  visibility: hidden;
}

.cat-c-contextual-pagination-list-item {
  display: block;
}
.cat-c-contextual-pagination-list-item .cat-c-contextual-pagination-item-text {
  padding-inline: 8px;
}

.cat-c-contextual-pagination-item {
  --cat-list-item-text-min-width: min-content;
}

.cat-c-pagination__item-ellipsis {
  --cat-button-padding: var(--cat-space-small) var(--cat-space-x-small) var(--cat-space-3x-small);
}

.cat-c-pagination__wrapper {
  display: flex;
  gap: calc(var(--size-base-unit) * --cat-space-x-small);
  align-items: center;
  justify-content: space-evenly;
}

.cat-c-pagination__small-pager {
  gap: calc(var(--size-base-unit) * 1.375);
}
`;
       